import { h, render } from "preact";
import { Site } from "./site";

render(<Site />, document.getElementById("site"));